import React from 'react'
import Breadcrumb from '../../components/common/Breadcrumb'
import {
    IconCheck,
    IconX,
} from '@tabler/icons-react'

export default function Attendance() {

    const attendanceItem = [
        {
            employee: "John Doe",
            children: [
                {
                    present: true,
                },
                {
                    present: true,
                },
                {
                    present: true,
                },
                {
                    present: false,
                },
                {
                    present: true,
                },
                {
                    present: true,
                },
                {
                    present: true,
                },
                {
                    present: false,
                },
                {
                    present: false,
                },
                {
                    present: true,
                },
                {
                    present: true,
                },
                {
                    present: true,
                },
                {
                    present: true,
                },
                {
                    present: true,
                },
                {
                    present: false,
                },
                {
                    present: true,
                },
                {
                    present: true,
                },
                {
                    present: true,
                },
                {
                    present: true,
                },
                {
                    present: true,
                },
                {
                    present: true,
                },
                {
                    present: true,
                },
                {
                    present: true,
                },
                {
                    present: false,
                },
                {
                    present: true,
                },
                {
                    present: true,
                },
                {
                    present: true,
                },
                {
                    present: true,
                },
                {
                    present: true,
                },
                {
                    present: false,
                },
                {
                    present: true,
                },
            ],
        },
        {
            employee: "Tim Hank",
            children: [
                {
                    present: true,
                },
                {
                    present: true,
                },
                {
                    present: true,
                },
                {
                    present: false,
                },
                {
                    present: true,
                },
                {
                    present: true,
                },
                {
                    present: true,
                },
                {
                    present: false,
                },
                {
                    present: false,
                },
                {
                    present: false,
                },
                {
                    present: true,
                },
                {
                    present: true,
                },
                {
                    present: true,
                },
                {
                    present: true,
                },
                {
                    present: false,
                },
                {
                    present: true,
                },
                {
                    present: true,
                },
                {
                    present: true,
                },
                {
                    present: true,
                },
                {
                    present: false,
                },
                {
                    present: true,
                },
                {
                    present: true,
                },
                {
                    present: true,
                },
                {
                    present: false,
                },
                {
                    present: true,
                },
                {
                    present: true,
                },
                {
                    present: true,
                },
                {
                    present: true,
                },
                {
                    present: false,
                },
                {
                    present: false,
                },
                {
                    present: true,
                },
            ],
        },
        {
            employee: "Frank Camly",
            children: [
                {
                    present: true,
                },
                {
                    present: true,
                },
                {
                    present: true,
                },
                {
                    present: false,
                },
                {
                    present: true,
                },
                {
                    present: true,
                },
                {
                    present: true,
                },
                {
                    present: false,
                },
                {
                    present: false,
                },
                {
                    present: true,
                },
                {
                    present: true,
                },
                {
                    present: true,
                },
                {
                    present: true,
                },
                {
                    present: true,
                },
                {
                    present: false,
                },
                {
                    present: true,
                },
                {
                    present: true,
                },
                {
                    present: true,
                },
                {
                    present: true,
                },
                {
                    present: true,
                },
                {
                    present: true,
                },
                {
                    present: true,
                },
                {
                    present: true,
                },
                {
                    present: false,
                },
                {
                    present: true,
                },
                {
                    present: true,
                },
                {
                    present: true,
                },
                {
                    present: true,
                },
                {
                    present: true,
                },
                {
                    present: false,
                },
                {
                    present: true,
                },
            ],
        },
        {
            employee: "Gary Camara",
            children: [
                {
                    present: true,
                },
                {
                    present: true,
                },
                {
                    present: true,
                },
                {
                    present: true,
                },
                {
                    present: true,
                },
                {
                    present: true,
                },
                {
                    present: true,
                },
                {
                    present: false,
                },
                {
                    present: false,
                },
                {
                    present: true,
                },
                {
                    present: true,
                },
                {
                    present: true,
                },
                {
                    present: true,
                },
                {
                    present: true,
                },
                {
                    present: true,
                },
                {
                    present: true,
                },
                {
                    present: true,
                },
                {
                    present: true,
                },
                {
                    present: true,
                },
                {
                    present: true,
                },
                {
                    present: true,
                },
                {
                    present: true,
                },
                {
                    present: true,
                },
                {
                    present: true,
                },
                {
                    present: true,
                },
                {
                    present: true,
                },
                {
                    present: true,
                },
                {
                    present: true,
                },
                {
                    present: true,
                },
                {
                    present: false,
                },
                {
                    present: true,
                },
            ],
        },
        {
            employee: "Fidel Tonn",
            children: [
                {
                    present: true,
                },
                {
                    present: true,
                },
                {
                    present: true,
                },
                {
                    present: false,
                },
                {
                    present: true,
                },
                {
                    present: true,
                },
                {
                    present: true,
                },
                {
                    present: false,
                },
                {
                    present: false,
                },
                {
                    present: true,
                },
                {
                    present: true,
                },
                {
                    present: true,
                },
                {
                    present: true,
                },
                {
                    present: true,
                },
                {
                    present: true,
                },
                {
                    present: true,
                },
                {
                    present: true,
                },
                {
                    present: true,
                },
                {
                    present: true,
                },
                {
                    present: true,
                },
                {
                    present: true,
                },
                {
                    present: true,
                },
                {
                    present: true,
                },
                {
                    present: false,
                },
                {
                    present: true,
                },
                {
                    present: true,
                },
                {
                    present: true,
                },
                {
                    present: true,
                },
                {
                    present: true,
                },
                {
                    present: true,
                },
                {
                    present: true,
                },
            ],
        },
        {
            employee: "Tim Hank",
            children: [
                {
                    present: true,
                },
                {
                    present: true,
                },
                {
                    present: true,
                },
                {
                    present: false,
                },
                {
                    present: true,
                },
                {
                    present: false,
                },
                {
                    present: true,
                },
                {
                    present: false,
                },
                {
                    present: false,
                },
                {
                    present: true,
                },
                {
                    present: true,
                },
                {
                    present: true,
                },
                {
                    present: true,
                },
                {
                    present: true,
                },
                {
                    present: false,
                },
                {
                    present: false,
                },
                {
                    present: true,
                },
                {
                    present: true,
                },
                {
                    present: true,
                },
                {
                    present: true,
                },
                {
                    present: true,
                },
                {
                    present: true,
                },
                {
                    present: true,
                },
                {
                    present: false,
                },
                {
                    present: true,
                },
                {
                    present: false,
                },
                {
                    present: true,
                },
                {
                    present: true,
                },
                {
                    present: true,
                },
                {
                    present: false,
                },
                {
                    present: true,
                },
            ],
        },
        {
            employee: "Maryam Amiri",
            children: [
                {
                    present: true,
                },
                {
                    present: true,
                },
                {
                    present: true,
                },
                {
                    present: false,
                },
                {
                    present: true,
                },
                {
                    present: true,
                },
                {
                    present: true,
                },
                {
                    present: false,
                },
                {
                    present: false,
                },
                {
                    present: true,
                },
                {
                    present: true,
                },
                {
                    present: false,
                },
                {
                    present: true,
                },
                {
                    present: false,
                },
                {
                    present: false,
                },
                {
                    present: true,
                },
                {
                    present: true,
                },
                {
                    present: true,
                },
                {
                    present: true,
                },
                {
                    present: true,
                },
                {
                    present: true,
                },
                {
                    present: true,
                },
                {
                    present: true,
                },
                {
                    present: false,
                },
                {
                    present: false,
                },
                {
                    present: true,
                },
                {
                    present: true,
                },
                {
                    present: true,
                },
                {
                    present: true,
                },
                {
                    present: false,
                },
                {
                    present: false,
                },
            ],
        },
        {
            employee: "Hossein Shams",
            children: [
                {
                    present: true,
                },
                {
                    present: true,
                },
                {
                    present: true,
                },
                {
                    present: false,
                },
                {
                    present: true,
                },
                {
                    present: true,
                },
                {
                    present: true,
                },
                {
                    present: true,
                },
                {
                    present: true,
                },
                {
                    present: true,
                },
                {
                    present: true,
                },
                {
                    present: true,
                },
                {
                    present: true,
                },
                {
                    present: true,
                },
                {
                    present: false,
                },
                {
                    present: true,
                },
                {
                    present: true,
                },
                {
                    present: true,
                },
                {
                    present: true,
                },
                {
                    present: true,
                },
                {
                    present: true,
                },
                {
                    present: true,
                },
                {
                    present: true,
                },
                {
                    present: true,
                },
                {
                    present: true,
                },
                {
                    present: true,
                },
                {
                    present: true,
                },
                {
                    present: true,
                },
                {
                    present: true,
                },
                {
                    present: false,
                },
                {
                    present: true,
                },
            ],
        },
    ]

    return (
        <>
            <Breadcrumb title="Attendance" path="Employees / Attendance" />
            <div className='bg-bg-dark rounded-lg shadow-light md:p-20 p-15'>
                <div className='overflow-auto'>
                    <table className='w-full min-w-[767px]'>
                        <thead>
                            <tr>
                                <th align='left' className='bg-bg-light-100 p-3'>
                                    EMPLOYEE
                                </th>
                                <th align='center' className='bg-bg-light-100 p-3'>
                                    1
                                </th>
                                <th align='center' className='bg-bg-light-100 p-3'>
                                    2
                                </th>
                                <th align='center' className='bg-bg-light-100 p-3'>
                                    3
                                </th>
                                <th align='center' className='bg-bg-light-100 p-3'>
                                    4
                                </th>
                                <th align='center' className='bg-bg-light-100 p-3'>
                                    5
                                </th>
                                <th align='center' className='bg-bg-light-100 p-3'>
                                    6
                                </th>
                                <th align='center' className='bg-bg-light-100 p-3'>
                                    7
                                </th>
                                <th align='center' className='bg-bg-light-100 p-3'>
                                    8
                                </th>
                                <th align='center' className='bg-bg-light-100 p-3'>
                                    9
                                </th>
                                <th align='center' className='bg-bg-light-100 p-3'>
                                    10
                                </th>
                                <th align='center' className='bg-bg-light-100 p-3'>
                                    11
                                </th>
                                <th align='center' className='bg-bg-light-100 p-3'>
                                    12
                                </th>
                                <th align='center' className='bg-bg-light-100 p-3'>
                                    13
                                </th>
                                <th align='center' className='bg-bg-light-100 p-3'>
                                    14
                                </th>
                                <th align='center' className='bg-bg-light-100 p-3'>
                                    15
                                </th>
                                <th align='center' className='bg-bg-light-100 p-3'>
                                    16
                                </th>
                                <th align='center' className='bg-bg-light-100 p-3'>
                                    17
                                </th>
                                <th align='center' className='bg-bg-light-100 p-3'>
                                    18
                                </th>
                                <th align='center' className='bg-bg-light-100 p-3'>
                                    19
                                </th>
                                <th align='center' className='bg-bg-light-100 p-3'>
                                    20
                                </th>
                                <th align='center' className='bg-bg-light-100 p-3'>
                                    21
                                </th>
                                <th align='center' className='bg-bg-light-100 p-3'>
                                    22
                                </th>
                                <th align='center' className='bg-bg-light-100 p-3'>
                                    23
                                </th>
                                <th align='center' className='bg-bg-light-100 p-3'>
                                    24
                                </th>
                                <th align='center' className='bg-bg-light-100 p-3'>
                                    25
                                </th>
                                <th align='center' className='bg-bg-light-100 p-3'>
                                    26
                                </th>
                                <th align='center' className='bg-bg-light-100 p-3'>
                                    27
                                </th>
                                <th align='center' className='bg-bg-light-100 p-3'>
                                    28
                                </th>
                                <th align='center' className='bg-bg-light-100 p-3'>
                                    29
                                </th>
                                <th align='center' className='bg-bg-light-100 p-3'>
                                    30
                                </th>
                                <th align='center' className='bg-bg-light-100 p-3'>
                                    31
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {attendanceItem.map((item, key) => (
                                <tr className='hover:bg-bg-light'>
                                    <td key={key} className='p-3 border-t border-border'>
                                        {item.employee}
                                    </td>
                                    {item.children.map((res, key) => (
                                        <td key={key} align='center' className='p-3 border-t border-border'>
                                            {res.present ? <IconCheck className='w-[18px] h-[18px] stroke-[2.5] text-success' /> : <IconX className='w-[18px] h-[18px] stroke-[2.5] text-danger' />}
                                        </td>
                                    ))}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </>
    )
}
